import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export default function Loader() {
  const spinner = <FontAwesomeIcon icon={faCircleNotch} className="icon is-large" spin />

  return (
    <div className="hero is-large">
      <div className="hero-head"></div>
      <div className="hero-body">
        <div className="container has-text-centered">
          {spinner}
        </div>
      </div>
      <div className="hero-foot"></div>
    </div>
  )
}
